import React, { useEffect, useState } from 'react';
import axios from 'axios';
import HomeVerticalNavbar from '../../components/VerticalNavBars/HomePage';
import Modal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';
import './TestScreen.css';
/* ------------------ ORDER UTIL ------------------ */
const moveItem = (list, fromIndex, toIndex) => {
  if (toIndex < 0 || toIndex >= list.length) return list;
  const updated = [...list];
  const [item] = updated.splice(fromIndex, 1);
  updated.splice(toIndex, 0, item);
  return updated;
};

const TestScreen = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [savingOrder, setSavingOrder] = useState(false);
  const [tests, setTests] = useState([]);
  const [filteredTests, setFilteredTests] = useState([]);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isRearranging, setIsRearranging] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');

  const [newTest, setNewTest] = useState({
    name: '',
    start_date: '',
    start_time: '',
    duration: '',
    end_date: '',
    end_time: ''
  });

  /* ------------------ FETCH ------------------ */
  useEffect(() => {
    axios
      .get('https://api.azad.deloai.com/admin/test/tests')
      .then(res => {
        setTests(res.data);
        setFilteredTests(res.data);
      })
      .catch(err => console.error(err));
  }, []);

  /* ------------------ SEARCH ------------------ */
  useEffect(() => {
    if (isRearranging) {
      setFilteredTests(tests);
      return;
    }

    if (!searchQuery) {
      setFilteredTests(tests);
    } else {
      setFilteredTests(
        tests.filter(t =>
          t.name.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }
  }, [searchQuery, tests, isRearranging]);

  /* ------------------ MODAL ------------------ */
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const handleChange = (e) => {
    setNewTest({ ...newTest, [e.target.name]: e.target.value });
  };

  /* ------------------ CREATE ------------------ */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        'https://api.azad.deloai.com/admin/test/tests',
        newTest
      );

      setTests(prev => [...prev, res.data]);
      setFilteredTests(prev => [...prev, res.data]);

      setNewTest({
        name: '',
        start_date: '',
        start_time: '',
        duration: '',
        end_date: '',
        end_time: ''
      });

      closeModal();
      alert('Test added successfully');
    } catch (err) {
      alert('Failed to add test');
    } finally {
      setLoading(false);
    }
  };

  /* ------------------ DELETE ------------------ */
  const deleteTest = async (id) => {
    if (!window.confirm('Delete this test')) return;

    try {
      await axios.delete(
        `https://api.azad.deloai.com/admin/test/tests/${id}`
      );
      setTests(prev => prev.filter(t => t.id !== id));
      setFilteredTests(prev => prev.filter(t => t.id !== id));
    } catch (err) {
      alert('Delete failed');
    }
  };

  /* ------------------ REORDER ------------------ */
  const moveUp = (index) => {
    setTests(prev => moveItem(prev, index, index - 1));
  };

  const moveDown = (index) => {
    setTests(prev => moveItem(prev, index, index + 1));
  };

  const saveRearrangement = async () => {
    setSavingOrder(true);
    try {
      await axios.post(
        'https://api.azad.deloai.com/admin/test/tests/reorder',
        { new_order: tests.map(t => t.id) }
      );
      alert('Order updated');
      setIsRearranging(false);
    } catch (err) {
      alert('Failed to save order');
    } finally {
      setSavingOrder(false);
    }
  };

  /* ------------------ UI ------------------ */
  return (
    <div className="test-screen">
      <HomeVerticalNavbar />

      <div className="content">
        <h2 className="test-heading2">All Tests ({tests.length})</h2>

        <div className="test-top-bar">
          <input
            type="text"
            placeholder="Search Tests"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            disabled={isRearranging}
            className="test-search-input"
          />

          <div>
            <button className="test-add-button" onClick={openModal}>
              Add Test
            </button>

            {!isRearranging && (
              <button onClick={() => setIsRearranging(true)}>
                Rearrange
              </button>
            )}

            {isRearranging && (
              <button 
                onClick={saveRearrangement}
                disabled={savingOrder}
              >
                {savingOrder ? '⏳ Saving...' : 'Save Order'}
              </button>
            )}
          </div>
        </div>

        {/* -------- REARRANGE MODE -------- */}
        {isRearranging ? (
          <div className="test-rearrange-grid">
            {tests.map((test, index) => (
              <div key={test.id} className="test-rearrange-card">
                <div className="test-card-title">{test.name}</div>
                <div className="test-card-actions">
                  <button
                    disabled={index === 0}
                    onClick={() => moveUp(index)}
                  >
                    ⬆
                  </button>
                  <button
                    disabled={index === tests.length - 1}
                    onClick={() => moveDown(index)}
                  >
                    ⬇
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          /* -------- NORMAL TABLE -------- */
          <table className="test-student-table">
            <thead>
              <tr>
                <th>Test Name</th>
                <th>Start Date</th>
                <th>Start Time</th>
                <th>Duration</th>
                <th>End Date</th>
                <th>End Time</th>
                <th>View</th>
                <th>Questions</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredTests.map(test => (
                <tr key={test.id}>
                  <td>{test.name}</td>
                  <td>{new Date(test.start_date).toLocaleDateString()}</td>
                  <td>{test.start_time}</td>
                  <td>{test.duration} min</td>
                  <td>{new Date(test.end_date).toLocaleDateString()}</td>
                  <td>{test.end_time}</td>
                  <td>
                    <Link to={`/tests/${test.id}`}>View</Link>
                  </td>
                  <td>
                    <Link to={`/tests/${test.id}/questions`}>
                      Add Questions
                    </Link>
                  </td>
                  <td>
                    <button
                      className="test-delete-button"
                      onClick={() => deleteTest(test.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* -------- MODAL -------- */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="test-modal"
        overlayClassName="test-modal-overlay"
      >
        <h2>Add Test</h2>
        <form onSubmit={handleSubmit}>
          {Object.entries(newTest).map(([key, value]) => (
            <label key={key}>
              {key.replace('_', ' ')}
              <input
                type={key.includes('date') ? 'date' : key.includes('time') ? 'time' : key === 'duration' ? 'number' : 'text'}
                name={key}
                value={value}
                onChange={handleChange}
                required
              />
            </label>
          ))}
          <button type="submit" disabled={loading}>Add</button>
          <button type="button" onClick={closeModal}>Cancel</button>
        </form>
      </Modal>
    </div>
  );
};

export default TestScreen;
